export const thirdPartyWebsiteLinks = [
  {
    header: "Third Party Links",
    answer:
      "The Platform may include links to websites maintained by third parties or feature services offered by these third parties (referred to as 'Third Party Services').",
  },
  {
    header: "Convenience Only",
    answer:
      "These Third Party Services are provided solely for your convenience.",
  },
  {
    header: "Lack of Control",
    answer:
      "HomeSwap, along with its subsidiaries and affiliates, does not have control over and is not responsible for: \n \n \
        • The content, products, or services provided by Third Party Services. \n \
        • The terms of use or privacy policies of these third parties.",
  },
  {
    header: "Member Responsibility",
    answer:
      "Members and Newcomers are solely responsible for adhering to the terms of use and privacy policies of any Third Party Services.",
  },
  {
    header: "No Endorsement",
    answer:
      "Links to third-party websites do not imply acceptance of responsibility, sponsorship, approval, or endorsement of those sites or their content.",
  },
];
